// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem/GridItem";
import Typography from "@insite/mobius/Typography";
import injectCss from "@insite/mobius/utilities/injectCss";
import ResponsiveButton, {
    ResponsiveButtonPresentationProps,
} from "@store/Library/Components/Toolkit/ResponsiveButton";
import LazyImage from "@store/MobiusOverrides/LazyImage/LazyImage";
import {
    OurOfferingStyles,
    OurOfferingTileFields,
    ctaSizeVariantField,
    ctaVariantField,
} from "@store/Library/Widgets/Basic/OurOfferingWidget";
import React, { useMemo } from "react";
import styled, { css } from "styled-components";

type Alignment = "flex-start" | "center" | "flex-end";

const TileCtaRow = styled(StyledWrapper)<{ alignment: Alignment }>`
    display: flex;
    width: 100%;
    justify-content: ${x => x.alignment};
    ${x => (x.alignment === "center" ? "text-align: center;" : null)}
    ${injectCss}
`;

const OurOfferingTile: React.FC<{
    tile: OurOfferingTileFields;
    index: number;
    styles: OurOfferingStyles;
    gridItemStyles: GridItemProps;
}> = ({ tile, index, styles, gridItemStyles }) => {
    const key = tile.id || `${index}`;
    const ctaLink = useGetLink(tile.ctaLink);

    const alignment = (tile.ctaAlignment || "flex-start") as Alignment;

    const ctaButtonStyles: ResponsiveButtonPresentationProps = useMemo(() => {
        return {
            ...styles.cta,
            variant: ctaVariantField.parse(tile.ctaVariant),
            sizeVariant: ctaSizeVariantField.parse(tile.ctaSizeVariant),
            css: css`
                ${styles.cta?.css}
                ${tile.ctaFullWidth ? "width: 100%;" : null}
            `,
            mergeCss: true,
        };
    }, [styles.cta, tile.ctaVariant, tile.ctaSizeVariant, tile.ctaFullWidth]);

    return (
        <GridItem key={key} {...gridItemStyles} className="tile">
            <StyledWrapper className="tile" {...styles.tile}>
                {!!tile.image && (
                    <StyledWrapper className="tileImageWrapper" {...styles.imageWrapper} aria-hidden="true">
                        <LazyImage className="tileImage" src={tile.image} {...styles.image} />
                    </StyledWrapper>
                )}

                <StyledWrapper className="tileBody" {...styles.body}>
                    {!!tile.title && (
                        <Typography className="tileTitle" {...styles.tileTitle}>
                            {tile.title}
                        </Typography>
                    )}

                    {!!tile.description && (
                        <Typography className="tileDescription" {...styles.description}>
                            {tile.description}
                        </Typography>
                    )}

                    {!!tile.ctaText && !!ctaLink?.url && (
                        <TileCtaRow className="tileCtaRow" {...styles.ctaRow} alignment={alignment}>
                            <ResponsiveButton
                                className="tileCta"
                                href={ctaLink.url}
                                target="_self"
                                {...ctaButtonStyles}
                            >
                                {tile.ctaText}
                            </ResponsiveButton>
                        </TileCtaRow>
                    )}
                </StyledWrapper>
            </StyledWrapper>
        </GridItem>
    );
};

export default OurOfferingTile;
